module.exports = __webpack_public_path__ + "static/media/real-estate.e8b5f03d.jpg";